export function evaluateProfile(params) {
  const suggestions = [];
  let totalScore = 12; // base score even if nothing is filled

  if (params.firstName) {
    totalScore += 8;
  } else {
    suggestions.push({ title: 'Add your first name', propertyName: 'firstName', points: 8 });
  }

  if (params.lastName) {
    totalScore += 8;
  } else {
    suggestions.push({ title: 'Add your last name', propertyName: 'lastName', points: 8 });
  }

  if (params.title) {
    totalScore += 10;
  } else {
    suggestions.push({ title: 'Add the job title', propertyName: 'title', points: 10 });
  }

  if (params.email) {
    totalScore += 12;
  } else {
    suggestions.push({ title: 'Add contact email', propertyName: 'email', points: 12 });
  }

  if (params.summary) {
    totalScore += 12;
  } else {
    suggestions.push({ title: 'Write a summary', propertyName: 'summary', points: 12 });
  }

  const hasExperience = params.experience?.some(exp => exp.companyName && exp.jobPosition);
  if (hasExperience) {
    totalScore += 12;
  } else {
    suggestions.push({ title: 'Add work experience', propertyName: 'experience', points: 12 });
  }

  const hasEducation = params.education?.some(edu => edu.universityName && edu.degreeName);
  if (hasEducation) {
    totalScore += 6;
  } else {
    suggestions.push({ title: 'Add education', propertyName: 'education', points: 6 });
  }

  if (params.skills && params.skills.length > 0) {
    totalScore += 12;
  } else {
    suggestions.push({ title: 'Add skills', propertyName: 'skills', points: 12 });
  }

  return { totalScore, suggestions };
}